import * as React from 'react';
import { observer } from 'mobx-react';

import { Filter, Sort } from '.';
import { useStores } from 'utility/hooks';

export interface SortFilterProps {
  keySuffix: string;
}

export const SortFilter = observer(({ keySuffix }: SortFilterProps) => {
  const { sortFilterStore } = useStores();
  const { revealAction } = sortFilterStore;

  return (
    <>
      {revealAction && revealAction.accessibility && revealAction.accessibility.usage && (
        <h2 className="is-visually-hidden">{revealAction.accessibility.usage}</h2>
      )}
      <form id="sort-and-filter" data-test-id="fsr-sort-filter-drawer">
        <Sort keySuffix={keySuffix} classes="elevation-1" hasVisibleLabel={false} />
        <Filter keySuffix={keySuffix} />
      </form>
    </>
  );
});
